import t3 from 't3';

var SNI = window.SNI = window.SNI || {};

// t3 compat
Object.assign(SNI, t3);